export { default } from './SignupThanks';
